<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :buttonNameSubmit="$route.params.vrioId ? 'Сохранить' : 'Добавить'"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";
import router from "@/router";

import {
  postUsersVrio as createData,
  updateUsersVrio as updateData,
  getUsersVrio,
} from "@/api/users";
import defaultScheme from "@/api/schemes/usersVrio";

const create = async (id, data) => {
  await createData({
    ...data,
    user_id: +id,
    user_vrio: data.user_vrio?.id ? +data.user_vrio.id : undefined,
    date_from: data.date_from ? new Date(data.date_from) : undefined,
    date_to: data.date_to ? new Date(data.date_to) : undefined,
  });
  await router.push({ name: "UsersVrioTable", params: { id } });
};

const update = async (id, data, { vrioId }) => {
  await updateData(vrioId, {
    ...data,
    user_id: +id,
    user_vrio: data.user_vrio?.id ? +data.user_vrio.id : undefined,
    date_from: data.date_from ? new Date(data.date_from) : undefined,
    date_to: data.date_to ? new Date(data.date_to) : undefined,
  });
  router.push({ name: "UsersVrioTable", params: { id } });
};

const middleware = async (id, data, params) => {
  const { vrioId } = params;

  if (vrioId) {
    await update(id, data, params);
  } else {
    await create(id, data);
  }
};

const fetchData = async (id, params) => {
  const vrioId = params.vrioId;

  // Если нет vrioId, то это создание нового пользователя и данные не нужно загружать
  if (!vrioId) return;

  const data = await getUsersVrio({ user_id: id });
  const vrioData = data?.rows?.find((row) => row.id === +vrioId);

  if (vrioData) {
    return {
      ...vrioData,
      user_vrio: {
        id: vrioData.user_vrio,
        name: vrioData.user_vrio_name,
      },
    };
  }
  return;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        createData: middleware,
        updateData: middleware,
        fetchData: fetchData,
      },
    };
  },
};
</script>
